import { LogLevel, OpenIdConfiguration } from "angular-auth-oidc-client";
import { AppConfiguration } from "../types/app-configuration";

export function openIdConfigFactory(appConfig: AppConfiguration) {
  let apiScope = 'api://' + appConfig.apiClientId + '/.default';
  let config: OpenIdConfiguration = {
    configId: 'appApiConfig',
    authority: 'https://login.microsoftonline.com/20e27700-b670-4553-a27c-d8e2583b3289/v2.0',
    redirectUrl: window.location.origin,
    clientId: appConfig.appClientId,
    scope: 'openid profile offline_access ' + apiScope,
    responseType: 'code',
    secureRoutes: [appConfig.apiRootUrl],
    silentRenew: true,
    useRefreshToken: true,
    logLevel: LogLevel.Debug,
    ignoreNonceAfterRefresh: true,
    maxIdTokenIatOffsetAllowedInSeconds: 600,
    issValidationOff: false,
    autoUserInfo: false
  };

  return config;
}
